<template>
<div class="chapter">
<div class="inner_page">
<p class="calibre_4" id="filepos6394"><span class="calibre7">In Honor of Michel Eyquem de Montaigne</span></p>
<p class="calibre_6"><span class="calibre9">(1533 – 1592)</span></p><div class="calibre_13"> </div>
<p class="calibre_11"><span class="calibre9">“We are born to inquire after Truth”…it belongs to a greater power to possess it. It is not as Democritus said, hid in the bottom of the deeps, but rather elevated to an infinite height in the divine knowledge!</span></p>
<p class="calibre_14"><span class="calibre9">—Michel Eyquem de Montaigne</span></p>
<p class="calibre_15"><span class="calibre7"><em class="italic">Nothing I See Means Anything</em></span></p><div class="calibre_1"> </div>
<p class="calibre_11"><span class="calibre9">The reason this is so is that I see nothing, and nothing has no meaning. It is necessary that I recognize this that I may learn to see. What I think I see now is taking the place of vision. I must let it go by realizing it has no meaning, so that vision may take its place.</span></p>
<p class="calibre_14"><span class="calibre9">—<em class="italic">A Course in Miracles</em></span></p> <div class="mbp_pagebreak" id="calibre_pb_3"></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// index_split_003.vue?1c2825c6